module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic.791956e5.ttf";